import { Button, Col, Row } from "antd";
import { colors } from "pages/Home/Home.styles";
import { ReactComponent as Facebook } from "../../assets/ic-Facebook.svg";
import { ReactComponent as Instagram } from "../../assets/ic-Instagram.svg";
import { ReactComponent as Phone } from "../../assets/ICON_TELF.svg";
import { ReactComponent as FooterLogoHorizontal } from "../../assets/LogoHorizontalMovil.svg";
import background2 from "./../../assets/FOOTER.jpg";
import { FooterAnt } from "./footerStyle";

const Footer = ({ country }) => {
  return (
        <div style={{backgroundColor: colors.background}}>
            <FooterAnt  image={background2} image2={background2}>
               
                        <svg width="100%" height="80" viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M-5,0 A40,50 0 0 0 110,0 A50,50 0 0 0 0,0 Z" fill={colors.background} />
                        </svg>
                      
                {/*************************************** Col left firts row ********************************************/}
                <Row style={{ maxWidth: "1440px", margin: "auto", }}>
                    <Col className="Col-leftfooter--logo separate main-cols" xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <FooterLogoHorizontal />
                    </Col>
                    <Col className="Col-leftfooter--info separate terminos main-cols" xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                <Button
                                    className='buttonWs'
                                    type="link"
                                    target="_blank"
                                    href='https://drive.google.com/file/d/18yK_Jd_LpxlADAFpdbzyw0QTmIMPUhJK/view?usp=sharing'
                                >
                                    Términos y Condiciones
                                </Button>
                                <Button
                                    className='buttonWs'
                                    type="link"
                                    target="_blank"
                                    href=' https://drive.google.com/file/d/1g2skZV-cy-kiudl37YynfFgJaUrnWE2E/view?usp=sharing'
                                >
                                    Habeas Data
                                </Button>
                                <Button
                                    className='buttonWs'
                                    type="link"
                                    target="_blank"
                                    href='https://drive.google.com/file/d/1DBEwBHOX1z6f7eTxyW9ad9N7mJV-C_72/view?usp=sharing'
                                >
                                    Políticas de Privacidad
                                </Button>
                                <Button
                                            className='buttonWs'
                                    type="link"
                                    target="_blank"
                                    href='https://drive.google.com/file/d/1mcFSrD7YLg-9SchTjSkpB9PrpFrgsx_p/view?usp=sharing'
                                >
                                    FAQ's
                                </Button>
                    </Col>
                    <Col className="Col-leftfooter--infoContact separate main-cols" xs={24} sm={12} md={12} lg={6} xl={6} xxl={6} >
                                <Row style={{rowGap: "10px"}}>
                                    <Col className="wpp-container">
                                        <Button
                                            className='buttonWs'
                                            target="_blank"
                                            href={country === "EC" ? `https://wa.me/593997220556?text=Hola Equipo iCancha!` : `https://wa.me/573157708440?text=Hola Equipo iCancha!`}
                                        >
                                            Escríbenos en WhatsApp
                                        </Button>
                                    </Col>
                                    <Col span={24} >
                                        <p>
                                            Llámanos a los teléfonos:
                                        </p>
                                    </Col>
                                    <Col span={24} >
                                       <div className="phone-number">
                                        <Phone width={15}/>
                                            <p>
                                                <span>+57 </span>315 770 8440
                                            </p>
                                       </div>

                                        <div className="phone-number">
                                            <Phone width={15}/>
                                            <p>
                                                <span>+593 </span>99 722 0556
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                    </Col>
                    {/*************************************** Col right firts row ********************************************/}
                    <Col className="main-cols"  xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
                        <Row className="Row-Content--social">
                            <Col span={24}>
                                <p className="default-text">
                                    Síguenos en:
                                </p>
                                <div className="social-media">
                                    <Button type="link" href='https://www.facebook.com/iCanchaCO/' target="_blank">
                                        <Facebook width={25} height={25} />
                                    </Button>
                                    <Button type="link" href='https://www.instagram.com/icancha/' target="_blank">
                                        <Instagram width={25} height={25}/>
                                    </Button>
                                    {/* <Button type="link" href='https://twitter.com/icancha_app' target="_blank">
                                        <Twitter className='icon-twitter' width={25} height={25} />
                                    </Button> */}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </FooterAnt>
        </div>
    );
};

export default Footer;
